import { ServiceFetcher } from "@decisions/server/ServiceFetcher";
export function setMapping(parameters, abortController) {
    return ServiceFetcher.fetch({ methodName: "SetMapping", methodUrl: "MappingDataService/js/SetMapping", abortController: abortController, authParamName: "userContext", parameters: parameters });
}
export function getSuggestions(parameters, abortController) {
    return ServiceFetcher.fetch({ methodName: "GetSuggestions", methodUrl: "MappingDataService/js/GetSuggestions", abortController: abortController, authParamName: "userContext", parameters: parameters });
}
export function addInput(parameters, abortController) {
    return ServiceFetcher.fetch({ methodName: "AddInput", methodUrl: "MappingDataService/js/AddInput", abortController: abortController, authParamName: "userContext", parameters: parameters });
}
